var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8759 9.83111C13.5627 7.46244 13.3445 4.15259 11.2214 2.02656C8.85477 -0.342104 5.01753 -0.342104 2.64994 2.02656C0.283354 4.39623 0.283354 8.23582 2.64994 10.6055C4.77411 12.7305 8.08106 12.9489 10.4476 11.2606L11.4123 12.2261C11.2325 12.9004 11.4062 13.6505 11.9355 14.1792L15.4111 17.6579C16.2 18.4474 17.4787 18.4474 18.2676 17.6579C19.0564 16.8683 19.0564 15.5885 18.2676 14.7989L14.7919 11.3202C14.2637 10.7905 13.5142 10.6166 12.8405 10.7966L11.8759 9.83111ZM9.79212 3.45705C11.3698 5.03616 11.3708 7.59589 9.79212 9.175C8.21439 10.7551 5.6569 10.7551 4.07918 9.175C2.50146 7.59589 2.50045 5.03616 4.07918 3.45705C5.6569 1.87694 8.21439 1.87694 9.79212 3.45705Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a63d9bd8.svg";
export { ForwardRef as ReactComponent };